import React, { useEffect, useState } from 'react';
import fixedImage from '../Images/ImageMessag.png'; // Replace with your actual image path

const FixedImageMessage = () => {
  const [whatsappNumber, setWhatsappNumber] = useState('');

  // Fetch the WhatsApp number from the API
  const fetchWhatsAppNumber = async () => {
    try {
      const response = await fetch(
        "https://backend.printtrio.co.uk/api/home/get-setting"
      );

      if (!response.ok) {
        throw new Error("Failed to fetch WhatsApp number.");
      }

      const data = await response.json();

      // Check if API response is successful and contains the WhatsApp number
      if (data.success && data.data.length > 0) {
        const fetchedNumber = data.data[0]?.whatsapp_number;
        if (fetchedNumber) {
          setWhatsappNumber(fetchedNumber.trim()); // Set WhatsApp number and trim whitespace
        }
      }
    } catch (error) {
      console.error("Error fetching WhatsApp number:", error);
    }
  };

  // Fetch WhatsApp number when the component mounts
  useEffect(() => {
    fetchWhatsAppNumber();
  }, []);

  const handleWhatsAppRedirect = () => {
    if (whatsappNumber) {
      const whatsappURL = `https://wa.me/${whatsappNumber}`;
      window.open(whatsappURL, '_blank'); // Opens in a new tab
    } else {
      console.error("WhatsApp number is not available.");
    }
  };

  return (
    <button
      className="fixed bottom-0 right-0 mb-4 mr-4 md:mb-8 md:mr-8 lg:mb-12 lg:mr-12 z-50"
      onClick={handleWhatsAppRedirect}
      disabled={!whatsappNumber} // Disable button if number is not fetched
    >
      <img
        src={fixedImage}
        alt="Fixed Message"
        className="w-12 h-auto md:w-16"
      />
    </button>
  );
};

export default FixedImageMessage;
